import {
  CLEAR_VOLCANO_EVENTS_DATA,
  DELETE_VOLCANO_EVENT_DATA_REQUEST,
  GET_VOLCANO_EVENT_DATA_REGION_REQUEST,
  VOLCANO_EVENT_DATA_TOGGLE_COLUMN,
  VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST,
  VOLCANO_EVENT_DATA_CANCEL_EDIT,
  VOLCANO_EVENT_DATA_EDIT,
  VOLCANO_EVENT_DATA_SAVE_CANCEL_CONFIRMATION,
  VOLCANO_EVENT_DATA_SAVE_OPEN_CONFIRMATION,
} from './volcanoEventDataReducer';
import { VOLCANO_EVENT_DATA_SORT } from '../search/volcanoEventSearchReducer';


export const clearVolcanoEventData = () => ({ type: CLEAR_VOLCANO_EVENTS_DATA });
export const deleteVolcanoEvent = ({ id, history }) => ({ type: DELETE_VOLCANO_EVENT_DATA_REQUEST, id, history });
export const getRegions = ({ history }) => ({ type: GET_VOLCANO_EVENT_DATA_REGION_REQUEST, history });
export const sortData = sort => ({ type: VOLCANO_EVENT_DATA_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: VOLCANO_EVENT_DATA_TOGGLE_COLUMN, visibleColumns });

export const bulkEditVolcanoEvents = ({ data }) => ({ type: VOLCANO_EVENT_DATA_BULK_EDIT_REQUEST, data });
export const openEditConfirmation = ({ formData, initialFormData }) => ({ type: VOLCANO_EVENT_DATA_SAVE_OPEN_CONFIRMATION, formData, initialFormData });
export const cancelEditConfirmation = () => ({ type: VOLCANO_EVENT_DATA_SAVE_CANCEL_CONFIRMATION });
export const startEdit = ({ initialValues }) => ({ type: VOLCANO_EVENT_DATA_EDIT, initialValues });
export const cancelEdit = () => ({ type: VOLCANO_EVENT_DATA_CANCEL_EDIT });
